import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Row, Col, Modal, notification } from "antd";
import { updateUser } from "../../../api/user.service";

const EditUserFormModal = ({ fetchAllUsers, UserData, onClose, isModalOpen, setIsModalOpen, handleOk, handleCancel, isViewOnly = false }) => {
    const [form] = Form.useForm();

    const [optionsStatus, setOptionsStatus] = useState([
        {
            value: 1,
            label: 'ENABLE'
        },
        {
            value: 0,
            label: 'DISABLE'
        },
    ]);

    const [options, setOptions] = useState([
        {
            value: 'PK',
            label: 'Pakistan (PK)'
        },
        {
            value: 'US',
            label: 'UNITED STATES (US)'
        },
    ]);
    const [optionsRole, setOptionsRole] = useState([
            {
                value: 2,
                label: 'Manager'
            },
            {
                value: 3,
                label: 'Agent'
            },
            {
                value: 4,
                label: 'Driver'
            },
        ]);
    useEffect(() => {
        if (UserData) {
            form.setFieldsValue({
                name: UserData.name,
                email: UserData.email,
                status: UserData.status,
                role: UserData.role,
                mobile: UserData.mobile,
                country_code: UserData.country_code,
            });
        } else {
            form.resetFields();
        }
    }, [UserData, form]);

    const onFinish = async (values) => {
        try {
            await updateUser(UserData.id, { ...values }); // Ensure ID is sent
            notification.success({ message: "User Edited" });
            fetchAllUsers();
            setIsModalOpen(false);
        } catch (error) {
            notification.error({ message: error.response.data.message });
            console.error("Error:", error);
        }
    };

    return (
        <Modal
            footer={null}
            destroyOnClose
            title={`${isViewOnly ? "View" : "Edit"} User`}
            open={isModalOpen}
            onCancel={handleCancel}
        >
            <Form form={form} layout="vertical" onFinish={onFinish} disabled={isViewOnly}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Name"
                            name="name"
                            rules={[{ required: true, message: "Please enter your name" }]}
                        >
                            <Input placeholder="Enter name" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[{ required: true, type: "email", message: "Please enter a valid email" }]}
                        >
                            <Input placeholder="Enter email" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Status"
                            name="status"
                            rules={[{ required: true, message: "Please select status" }]}
                        >
                            <Select
                                className='vt-sel'
                                placeholder="Select status"
                                style={{ height: '37px !important', borderRadius: '8px !important' }}
                                options={optionsStatus}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Role"
                            name="role"
                            rules={[{ required: true, message: "Please select a role" }]}
                        >
                            <Select
                                className='vt-sel'
                                placeholder="Select role"
                                style={{ height: '37px !important', borderRadius: '8px !important' }}
                                options={optionsRole}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Mobile"
                            name="mobile"
                            rules={[{ required: true, message: "Please enter your mobile number" }]}
                        >
                            <Input placeholder="Enter mobile number" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Country Code"
                            name="country_code"
                            rules={[{ required: true, message: "Please select a country code" }]}
                        >
                            <Select
                                className='vt-sel'
                                placeholder="Select country code"
                                style={{ height: '37px !important', borderRadius: '8px !important' }}
                                options={options}
                            />
                        </Form.Item>
                    </Col>
                </Row>



                {!isViewOnly && <Form.Item>
                    <Button type="primary" htmlType="submit">Submit</Button>
                </Form.Item>}
            </Form>
        </Modal>
    );
};

export default EditUserFormModal;
